export default __webpack_public_path__ + "static/media/desktop-flower.32b8e53f.png";